module.exports = __webpack_public_path__ + "img/documents.5eda0cee.svg";